import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {SettingsParcelsComponent} from './settings-parcels.component';
import {SettingsParcelsService} from '../../services/settings-parcels.service';
import {SettingsParcelsDetailedViewComponent} from './settings-parcels-detailed-view/settings-parcels-detailed-view.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {SettingsParcelsListComponent} from './settings-parcels-list/settings-parcels-list.component';
import {PackageTypeModalComponent} from './package-type-modal/package-type-modal.component';
import {DragulaModule} from 'ng2-dragula';
import {CourierTypeModalComponent} from './courier-type-modal/courier-type-modal.component';
import {NotificationModalComponent} from './notification-modal/notification-modal.component';
import {ReminderTextModalComponent} from './reminder-text-modal/reminder-text-modal.component';
import {SmsNotificationModalComponent} from './sms-notification-modal/sms-notification-modal.component';
import {SmsReminderTextModalComponent} from './sms-reminder-text-modal/sms-reminder-text-modal.component';
import {UtilsModule} from '../../modules/utils/utils.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        DragulaModule,
        UtilsModule
    ],
    declarations: [
        SettingsParcelsComponent,
        SettingsParcelsDetailedViewComponent,
        SettingsParcelsListComponent,
        PackageTypeModalComponent,
        CourierTypeModalComponent,
        NotificationModalComponent,
        ReminderTextModalComponent,
        SmsNotificationModalComponent,
        SmsReminderTextModalComponent
    ],
    providers: [
        SettingsParcelsService
    ]
})
export class SettingsParcelsModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/settings-parcels.module.ts